<template>
  <b-container fluid class="pt-3 row">
    <div class="col-md-3 col-lg-3 col-xl-2 col-sm-3 col-xs-12">
      <b-card no-body header>
        <b-list-group flush>
          <b-list-group-item
            to="/settings/basic"
            :active="this.$route.path.indexOf('basic')>0"
          >
            <i class="fa fa-home" aria-hidden="true"></i>&nbsp;基本信息
          </b-list-group-item>
          <b-list-group-item
            to="/settings/mail-account"
            :active="this.$route.path.indexOf('mail-account')>0"
            v-if="appId==='standard'"
          >
            <i class="fa fa-envelope-o" aria-hidden="true"></i>&nbsp;邮箱账号
          </b-list-group-item>
          <b-list-group-item
            to="/settings/mail-whitelist"
            :active="this.$route.path.indexOf('mail-whitelist')>0"
            v-if="appId==='standard'"
          >
            <i class="fa fa-paper-plane-o" aria-hidden="true"></i>&nbsp;发件人白名单
          </b-list-group-item>
          <b-list-group-item
            to="/settings/ent"
            :active="this.$route.path.indexOf('ent')>0"
          >
            <i class="fa fa-building-o" aria-hidden="true"></i>&nbsp;企业列表
          </b-list-group-item>
          <b-list-group-item
            to="/settings/prod-blacklist"
            :active="this.$route.path.indexOf('prod-blacklist')>0"
            v-if="appId==='standard'"
          >
            <i class="fa fa-hand-paper-o" aria-hidden="true"></i>&nbsp;商品黑名单
          </b-list-group-item>
          <b-list-group-item
            to="/settings/users"
            :active="this.$route.path.indexOf('users')>0"
          >
            <i class="fa fa-users" aria-hidden="true"></i>&nbsp;用户管理
          </b-list-group-item>
          <b-list-group-item
            to="/settings/recharge"
            :active="this.$route.path.indexOf('recharge')>0"
            v-if="appId==='standard'"
          >
            <i class="fa fa-credit-card" aria-hidden="true"></i>&nbsp;充值记录
          </b-list-group-item>
          <b-list-group-item
            to="/settings/trans"
            :active="this.$route.path.indexOf('trans')>0"
            v-if="appId==='standard'"
          >
            <i class="fa fa-exchange" aria-hidden="true"></i>&nbsp;计费
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
    <div class="col-md-9 col-lg-9 col-sm-9 col-xl-10 col-xs-12 col-xs-12">
      <router-view :orgId='orgId'></router-view>
    </div>
  </b-container>
</template>

<script>
import * as orgFacade from "../../../api/org-facade.js";

export default {
  // validations:
  data() {
    return {
      orgId: "",
      appId: "standard"
    };
  },

  created() {
    this.init();
  },
  mounted() {
  },
  methods: {
    //点击菜单
    clickMenu(value) {
      this.activeName = value;
    },

    // 获取当前用户的机构信息
    getOrgInfo(){
      this.pageLoading = true;
      orgFacade
        .getUserOrgInfo()
        .then(res => {
          this.pageLoading = false;
          let curOrgId = res.id
          this.orgId = curOrgId;

          this.appId = (this.orgId==process.env.VUE_APP_MAERSK_ORG_ID) ? "maersk" : "standard";
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },

    // 初始化
    init(){
      this.orgId = this.$route.query.orgId;

      if(this.orgId==null){
        this.getOrgInfo();

      }

    }
  }
};
</script>

<style >
</style>
